module.exports = __webpack_public_path__ + "static/BTS_Dropbears-5dc84d2d49409eab3df2f4d8fc616b4d.jpg";